import { render, staticRenderFns } from "./campaignExpired.vue?vue&type=template&id=222a3930&"
import script from "./campaignExpired.vue?vue&type=script&lang=js&"
export * from "./campaignExpired.vue?vue&type=script&lang=js&"
import style0 from "./campaignExpired.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports